// extracted by mini-css-extract-plugin
module.exports = {"container":"TabPills_container__3qwVS","tab":"TabPills_tab__1A1We","active":"TabPills_active__Z2v_l"};